import React from "react";
import "./GradientButton.css"; 

const GradientButton = ({ label, onClick,type }) => {
  return (
    <button
      className="gradient-button "
      onClick={onClick}
      type={type}
    >
      {label}
    </button>
  );
};

export default GradientButton;
